enum Operator {
  AND = 'AND',
  OR = 'OR'
}

export default Operator
